<template>
    <div>
        <div style="margin: 4.533vw 0 5.067vw 5.333vw;font-size: 5.6vw;font-weight: bold;">My Orders</div>
        <div style="margin-left: 5.333vw;display: flex;">
            <div style="position: relative;margin-right: 2.4vw;">
                <input type="text" v-model="sousuo" class="int" placeholder="Enter order no." @input="sousuoBtn">
                <img src="@/assets/imgs/uploads/Group 104.png" alt=""
                    style="position: absolute;width: 4.965vw;height: 5.163vw;right: 2%;top: 11%;">
            </div>
            <img @click="export1()" src="@/assets/imgs/uploads/mobile/Group 651.png" style="width: 7.2vw;height: 7.2vw;"
                alt="">
        </div>
        <div class="tit">
            <div class="Tab" @click="changeTab1('')" :class="{ 'active1': currentTab1 === '' }">ALL
            </div>
            <div class="Tab" @click="changeTab1(2)" :class="{ 'active1': currentTab1 === 2 }">
                DELIVERING</div>
            <div class="Tab" @click="changeTab1(1)" :class="{ 'active1': currentTab1 === 1 }">
                PROCESSING</div>
            <div class="Tab" @click="changeTab1(0)" :class="{ 'active1': currentTab1 === 0 }">
                PENDING</div>
        </div>
        <div class="orders" v-if="orders.length > 0">
            <el-card shadow="always" style="margin-bottom: 5.333vw;" v-for="(item, index) in orders" :key="index">
                <div class="tittop">
                    <div class="stus" :style="getOrderStyle(item)">{{ getStatusText(item.status) }}
                    </div>
                    <p v-if="item.status == 1" class="Track">Track Shipment ></p>
                </div>
                <div class="lists">
                    <div><b>Order No.</b><span @click="showSub(item.id)">{{ item.orderNo }}</span></div>
                    <div><b>Order Date</b>{{ item.createTime | dateFormat }}</div>
                    <div><b>Quantity</b>{{ item.totalQty }}</div>
                    <div><b>Amount</b>${{ item.totalAmount }}</div>
                </div>
            </el-card>
        </div>
        <div v-else>
                <div style="display: flex;justify-content: center;align-items: center;margin: 16vw auto;">
                    <div style="font-size: 12px;color: #B3B3B3;">No Orders Yet</div>
                </div>
            </div>
    </div>
</template>

<script>
import { saveAs } from "file-saver"
export default {
    data() {
        return {
            currentTab1: '',
            currentType: 0,
            orders: [],// 订单列表
            sousuo: ''
        }
    },
    mounted() {
        this.activated()
    },
    methods: {
        sousuoBtn() {
            this.$axios
                .post("/api/mall/order/getPageList", {
                    memberId: this.$store.getters.getUser.id,
                    status: this.currentType,
                    orderNo: this.sousuo
                })
                .then(res => {
                    if (res.data.code === 200) {
                        this.orders = res.data.data;
                    } else {
                        this.notifyError(res.data.message);
                    }
                    // console.log(this.orders)
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        changeTab1(index) {
            this.currentTab1 = index;
            this.currentType = index;
            this.$axios
                .post("/api/mall/order/getPageList", {
                    memberId: this.$store.getters.getUser.id,
                    status: this.currentType,
                })
                .then(res => {
                    if (res.data.code === 200) {
                        this.orders = res.data.data;
                    } else {
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        showSub(id) {
            this.$router.push({
                path: '/Personalcenter/Ordersub',
                query: {
                    id: id
                }
            })
        },
        getStatusText(status) {
            switch (status) {
                case 0:
                    return 'Pending';
                case 1:
                    return 'processing';
                case 2:
                    return 'delivering';
                default:
                    return 'null';
            }
        },
        getOrderStyle(item) {
            return {
                color: this.getBorderColor(item.status),
                backgroundColor: this.getStatusColor(item.status),
                borderColor: this.getBorderColor(item.status),
            };
        },
        getStatusColor(status) {
            switch (status) {
                case 0:
                    return '#EDE2FF';
                case 1:
                    return '#FFF5CE';
                case 2:
                    return '#D9D9D9';
                default:
                    return 'white';
            }
        },
        getBorderColor(status) {
            switch (status) {
                case 0:
                    return '#8A43FF';
                case 1:
                    return '#FFB800';
                case 2:
                    return '#959595';
                default:
                    return 'black';
            }
        },

        activated() {
            // 获取订单数据
            this.$axios
                .post("/api/mall/order/getPageList", {
                    memberId: this.$store.getters.getUser.id,
                })
                .then(res => {
                    if (res.data.code === 200) {
                        this.orders = res.data.data;
                    } else {
                        this.notifyError(res.data.message);
                    }
                    // console.log(this.orders)
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        export1() {
            this.$axios
                .post("/api/mall/order/getExportList", {
                    memberId: this.$store.getters.getUser.id,
                    status: this.currentType,
                    orderNo: this.sousuo
                }, { responseType: "blob" })
                .then(res => {
                    const obj = res.data
                    saveAs(obj, '订单.xlsx')
                })
        }
    },

}
</script>

<style scoped>
.tit {
    height: 55px;
    width: 100%;
    display: flex;
    margin-top: 23px;
    border-top: 1px solid #D9D9D9;
    border-bottom: 1px solid #D9D9D9;
}

.Tab {
    width: 72px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    font-size: 10px;
    color: #959595;
}

.active1 {
    font-weight: bold;
    color: #000 !important;
    border-bottom: 5px solid #000;
}

.int {
    width: 211px;
    height: 27px;
    border: 1px solid #959595;
    border-radius: 5px;
    padding-left: 19px;
}


.content .centered-table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
}

.stus {
    width: 78px;
    height: 22px;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    border-radius: 23px;
    border: 1px solid #959595;
}

.content th {
    border-bottom: 1px solid #D9D9D9;
    padding: 8px;
    text-align: center;
}

.content td {
    border-bottom: 1px solid #D9D9D9;
    padding: 8px;
    text-align: center;
    height: 86px;
}

.orders {
    background-color: #F1F1F1;
    min-height: 310px;
    padding: 10px 13px 50px 7px;
}

::v-deep .el-card {
    border-radius: 10px;
}

::v-deep .el-card__body {
    padding: 0;
}

::v-deep .el-card.is-always-shadow {
    -webkit-box-shadow: 0 2px 0.32rem 0 rgba(0, 0, 0, .3);
    box-shadow: 0 2px 0.32rem 0 rgba(0, 0, 0, .3);
}

.tittop {
    height: 44px;
    padding: 0 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #EAEAEA;
}

.Track {
    font-size: 12px;
    color: #4583E1;
    text-decoration: underline;
}

.lists {
    padding: 19px 0 0 13px;
    font-size: 14px;
    color: #333;
}
.lists div {
    margin-bottom: 30px;
}
.lists b {
    color: #545454;
    display: inline-block;
    width: 75px;
    margin-right: 24px;
}

.lists span {
    text-decoration: underline;
    font-weight: bold;
}

/*我的订单结束*/</style>